import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'
import Slider from 'react-rangeslider'
import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Adjustment from './Adjustment';
import {IconLayerUp,IconLayerDonw,IconClone,IconTrash} from './Icons';
import Delete from './Delete';
@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class CanvaTool extends Component{

  @observable trans = {
      };

  @observable showCanvaTool = false;
  @observable coords = {
    left: '0px',
    top: '0px',
    display: 'none'
  }

  @observable showDelete = false;

  handleCanvaTool = null;
  activeElement = null;

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

    $(window).on('WorkArea-selectCanvasElem',(e,active)=>{
      this.coords.display = 'flex';
      this.activeElement = active;
      this.calcAndSetPosition(active,'select');

    })

    $(window).on('WorkArea-deselectCanvasElem Tools-changeView Tools-hideCanvaTool',(e,idLayer)=>{

      this.coords.display = 'none';
      this.showDelete = false;
      this.activeElement = null;
    })

    $(window).on('WorkArea-moveCanvasElem  ',(e,active)=>{

      this.calcAndSetPosition(active,'move');
    })


    $(window).on('WorkArea-doSomeTransform  ',(e,active)=>{

      this.calcAndSetPosition(active,'transform');
    })



    $(window).on('WorkArea-scalingCanvasElem',(e,obj)=>{

      this.calcAndSetPosition(obj.instance,'scaling');
    })
  }

  calcAndSetPosition(active,from){

    if ( !active ) return;
    let top = $('#creator-canvas').offset().top - $('#creator-area-container').offset().top;
    let left = $('#creator-canvas').offset().left - $('#creator-area-container').offset().left;


    let topCoords =   Math.max(active.aCoords.tl.y,active.aCoords.tr.y,active.aCoords.bl.y,active.aCoords.br.y);
    this.coords.top = top + topCoords + 45 +  'px';

    if ( this.coords.top.replace('px','') >  ( $('#creator-area-container').offset().top + $('#creator-area-container').height() -155 + 80 ) )
    {
      this.coords.top = $('#creator-area-container').offset().top + $('#creator-area-container').height() -155 +  80 + 'px';
    }

    this.coords.left = ( left +  active.left  )  - this.handleCanvaTool.offsetWidth/2 +  'px';

    if ( this.coords.left.replace('px','') <  ( $('#creator-area-container').position().left +3 ) )
    {
      this.coords.left =  ( $('#creator-area-container').position().left +3 ) + 'px';
    }
    else {
      if ( this.coords.left.replace('px','') > ( $('#creator-area-container').position().left + $('#creator-area-container').width() - 290 ) )
      {
        this.coords.left =  ( $('#creator-area-container').position().left + $('#creator-area-container').width() - 290 )  + 'px';
      }
    }

    if ( this.coords.left.replace('px','') < 2 ) this.coords.left = '2px';

  }

  clickClone(){
    $(document).trigger("copy");
    $(document).trigger('paste');
  }
  clickLayerUp(){
    bfLayers.layerUp(this.activeElement.idLayer);
  }
  clickLayerDown(){
    bfLayers.layerDown(this.activeElement.idLayer);
  }
  clickTrash(){
    this.showDelete = !this.showDelete;
  }

  onDelete(){
    bfLayers.removeLayerById(this.activeElement.idLayer);
    this.coords.display = 'none';
    this.activeElement = null;

  }

  onCancel(){
    this.showDelete = false;
  }

    render() {

    const t = this.t;
    const coords = toJS(this.coords);

    let adjustment = {name:'opacity',icon:'fa-sun-o',component:'IconOpacity',text:this.t('Opacity'),start: 100,min: 0,max: 100};

    return (
      <div className="CanvaTool" style={coords} ref={(input)=>{ this.handleCanvaTool = input }}>
        <div className="CanvaTool-opacity">
          <label>Opacity</label>
          <Adjustment
            dictionaryStorage={this.props.dictionaryStorage}
            show={['opacity']}
            idLayer={ (this.activeElement != null ? this.activeElement.idLayer : undefined ) }
          />
        </div>
        <button onClick={ ()=> { this.clickClone() } }><IconClone/></button>
        <button onClick={ ()=> { this.clickLayerUp() } }><IconLayerUp/></button>
        <button onClick={ ()=> { this.clickLayerDown() } }><IconLayerDonw/></button>
        <div className="CanvaTool-buttonContainer">
          <button onClick={ ()=> { this.clickTrash() } }><IconTrash/></button>
          {
            this.showDelete
            &&
            <Delete
              dictionaryStorage={this.props.dictionaryStorage}
              dingsPosition="top"
              onDelete={ ()=> { this.onDelete() } }
              onCancel={ ()=> { this.onCancel() } }
            />
          }
        </div>
      </div>
    );


   // ReactDOM.render(dom, document.getElementById('transforms'));

  }
}


